<template>
  <div id="app">
    <nav-header v-if="$store.state.isCy"></nav-header>
    <router-view></router-view>
    <!-- 弹窗TGDialogS(elmId) -->
    <!-- 您的账号还未绑定认证手机 -->
    <div class="dialog" id="dia1">
      <div class="dia dia1">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit-yy"></div>
        <div class="dia-tip" id="">您的账号还未绑定认证手机</div>
        <a href="http://member.changyou.com/info_framework/parent_frame_aq_new.jsp?name=phone" title="前往绑定"
          class="btn btn-bg2 dia-btn" target="_blank">
          前往绑定
        </a>
      </div>
    </div>
    <!-- 该账号已经预约过了 -->
    <div class="dialog" id="dia2">
      <div class="dia dia1">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit-sb"></div>
        <div class="dia-tip" id="">
          该账号已经预约过了 <br />
          请勿重复预约
        </div>
      </div>
    </div>

    <!-- 预约成功 -->
    <div class="dialog" id="dia4">
      <div class="dia dia1 diaTipcg">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit-cg"></div>
        <div class="dia-tip" id="">
          预约奖励可在新服开启后，至大理<br /> (171,123)龚彩云处领取。 <br />
          您的新手卡卡号为<span>{{
            $store.state.userInfo?.cdkey
              ? $store.state.userInfo?.cdkey
              : '--'
          }}</span>
        </div>
        <a href="javascript:;" @click="copyCdk($store.state.userInfo?.cdkey)" class="btn btn-bg2 dia-btn">复制卡号</a>
      </div>
    </div>
    <!-- 领取成功 -->
    <div class="dialog" id="dia5">
      <div class="dia dia1">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit1"></div>
        <div class="dia-tip" id="">
          请您在开服后前往大理 <br>
          (171,123)龚彩云处领取
        </div>
      </div>
    </div>
    <!-- 通用提示弹窗 -->
    <div class="dialog" id="diaTip">
      <div class="dia dia1 dia_ty">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tip" id="diaTipText">
          预约阶段已结束
        </div>
      </div>
    </div>
    <!-- 回归规则 -->
    <div class="dialog" id="dia10">
      <div class="dia dia1 dia_rules">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit0"></div>
        <div class="dia-tip" v-if="$store.state.isCy">
          <p>1.领奖时间：即日起至2026年2月27日19:00</p>
          <p>2.领取规则：2026年2月1日后再未登录过游戏的少侠（账号维度下未在此之后登录，最高角色等级≥50级，历史累积消费≥100元。）可以额外领取一份老友回归礼。</p>
          <p>3.老友回归礼可连续使用7天，每天使用后依次获得不同的奖励。</p>
          <p>4.原始新服&常规新服将同步发放老友回归奖励。</p>
          
        </div>
        <div class="dia-tip" v-else>
          <p>1.领奖时间：即日起至2026年2月24日19:00</p>
          <p>2.领取规则：2026年1月28日后再未登录过游戏的少侠（账号维度下未在此之后登录，最高角色等级≥50级，历史累积消费≥100元。）可以额外领取一份老友回归礼。</p>
          <p>3.老友回归礼可连续使用7天，每天使用后依次获得不同的奖励。</p>
        </div>
      </div>
    </div>
    <!-- 消费礼规则 -->
    <div class="dialog" id="dia7">
      <div class="dia dia1 dia_rules">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit0_2"></div>
        <div class="dia-tip">
          <p>1.少侠可在即日起至2026年2月27日19:00期间，点击查询消费按钮查询自己的历史消费元宝数并点击礼包领取按钮，领取对应消费档位的返利道具到开年大服中（原始服和常规服可同步领取，例：少侠预约了原始服新服并领取了返利道具，即可在原始服新服及常规服新服中同步领取到返利道具）。<span>同一实名下仅限两个账号领取消费返利奖励。</span></p>
          <p>2.在页面上领取礼包后，少侠可在2026年2月24日19:00常规新服开服后/2月27日19:00原始新服开服后前往大理（171，123）龚彩云处领取返利道具。请少侠在开服后及时领取，如未领取，道具将于2026年3月27日24:00失效。</p>
          <p>3.关于累积消费元宝规则说明：</p>
          <p>① 本次新服返利统计历史消费元宝的规则同年终回馈消费统计规则，根据少侠查询账号对应的实名下所有账号的历史消费元宝之和，统计时间为2020年10月16日开服后至2026年2月1日24：00期间，在元宝商城消费、神秘商人消费、一键强化、一键提升珍兽悟性、灵性等消费总额，与其他角色交易元宝不计入消费统计中。</p>
          <p>② 本次返利奖励领取模式为向下等级兼容式领取，例：账号历史累积消费元宝达到200000-399999元宝，则可领取0-399999档位的全部返利道具。</p>
          
        </div>
      </div>
    </div>
    <!-- 抽奖规则 -->
    <div class="dialog" id="dia8">
      <div class="dia dia1 dia_rules">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit4"></div>
        <div class="dia-tip" v-if="$store.state.isCy">
          <p>1.任务统计规则：任务完成情况将以<span>少侠预约服务器中的角色为目标进行统计</span>，若少侠预约常规新服，但在原始新服中完成指定任务，将无法在页面中领取对应的抽奖券。</p>
          <p>2.抽奖券获得：活动期间，完成页面上的指定任务可获得抽奖券，其中领取指定周活跃值任务为每周二刷新，少侠可每周完成一次领取400/800/1200周活跃值奖励任务（若少侠周日完成领取周活跃值任务，次周一可在页面上领取抽奖券，周二将刷新周活跃值任务统计）。每次完成都将获得一张抽奖券。因数据统计延迟，完成任务后将于次日中午12:00后显示在页面中。任务统计时间为2026年2月24日19:00-3月24日24:00。</p>
          <p>3.超级大奖-价值6000元的马年限定黄金将从本次活动中累抽次数达到5次的玩家中随机抽取。</p>
          <p>奖励领取说明：<br>
          (1).本次活动获得的实物周边、道具等奖励，可在【个人中心】中查看。<br>
          虚拟道具奖励在页面抽取后，少侠可前往大理（171，123）龚彩云处领取，如未领取，道具将于2026年3月25日24:00失效。<br>
          (2).实物奖励将于活动结束后的15个工作日内安排寄送，请在中奖后7日内填写收件信息，逾期未填写或误填收件信息视为放弃奖励资格。<br>
          (3).如使用外挂、作弊器等不正当方式参与本活动，官方有权取消违规用户参与资格及获奖资格。</p>


        </div>
        <div class="dia-tip" v-else>
          <p>1.抽奖券获得：<br>
            活动期间，完成页面上的指定任务可获得抽奖券，其中领取指定周活跃值任务为每周二刷新，少侠可每周完成一次领取400/800/1200周活跃值奖励任务（若少侠周日完成领取周活跃值任务，次周一可在页面上领取抽奖券，周二将刷新周活跃值任务统计）。每次完成都将获得一张抽奖券。因数据统计延迟，完成任务后将于次日中午12:00后显示在页面中。任务统计时间为2026年2月24日19:00-3月24日24:00。</p>
          <p>奖励领取说明： <br>
            (1).本次活动获得奖励，少侠可在【个人中心】中查看。虚拟道具奖励在页面抽取后，少侠可前往大理（171，123）龚彩云处领取，如未领取，道具将于2026年3月25日24:00失效。</p>
        </div>

      </div>
    </div>
    <div class="dialog-login" v-show="$store.state.isDiaLogin">
      <div class="login-box">
        <a href="javascript:;" class="dia-close" @click="$store.state.isDiaLogin = false">X</a>
        <iframe :src="$store.state.LoginSrc" frameborder="0" width="490" height="388"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
// 引入js
import Swiper from 'swiper';
// 引入css
import 'swiper/css/swiper.css';
import store from '@/store/index.js';
import { userPost } from './request';
import NavHeader from '@/components/Nav.vue';
export default {
  name: 'app',
  components: {
    NavHeader,
    // HomeView,
  },
  methods: {

    async init() {
      if (
        localStorage.getItem('userInfo'+this.$store.state.isCy) == 'undefined' ||
        !localStorage.getItem('userInfo'+this.$store.state.isCy)
      ) {
        localStorage.removeItem('userInfo'+this.$store.state.isCy);
        // localStorage.clear();
      }
      // 如果是邀请链接 弹出客态弹窗
      if (window.location.href.indexOf('inviteCode') != -1) {
        this.isDiaKt = true;
      }
      // 如果第一次登录或已经登陆过 直接请求数据
      if (window.location.href.indexOf('ticket') != -1) {
        // 获取用户信息  ---  如果登陆过本地有缓存跳过此次登录信息
        if (!localStorage.getItem('userInfo'+this.$store.state.isCy)) {
          // 获取aes
          await this.getAes();
          await this.getUserData();
          setTimeout(() => {
            // 保留inviteCode参数，删除其他参数
            const url = new URL(window.location.href);
            const searchParams = new URLSearchParams();

            // 只保留inviteCode参数
            const inviteCode = url.searchParams.get('inviteCode');
            if (inviteCode) {
              searchParams.append('inviteCode', inviteCode);
            }

            // 构建新的URL
            const cleanURL = url.origin + url.pathname + (searchParams.toString() ? '?' + searchParams.toString() : '');

            // 使用replaceState替换当前历史记录，不刷新页面
            window.history.replaceState({}, document.title, cleanURL);


            this.$watch(
              () => this.$store.state.userInfo?.inviteCode, // 监听邀请码变化
              (newInviteCode, oldInviteCode) => {
                if (newInviteCode && newInviteCode !== oldInviteCode) {
                  // 邀请码存在且发生变化时，重新初始化分享
                  this.wxInitShare();
                }
              },
              { immediate: true } // 立即执行一次（处理页面加载时已登录的情况）
            );
          }, 200);
        }

      }
      if (localStorage.getItem('userInfo'+this.$store.state.isCy)) {
        // 查询预充值点数
        this.getCzData();
        // 查询礼包领取记录
        this.getGiftRecord();
        // // 查询受邀人列表
        // this.getInviteList();
        // // 查询邀请礼状态
        // this.queryInviteGift();
        // // 初始化微信分享
        // // 查询自己是否回归
        this.oldFriend();


        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('ticket');
        const newUrl = window.location.origin + window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
        window.history.replaceState({}, '', newUrl);
        // this.$store.dispatch('fetchUinStatus');
        this.$store.commit('CHECK_USER_BANNED');
      }
    },
    // 获取加密aes
    async getAes() {
      // 从search部分获取参数
      const urlParams = new URLSearchParams(window.location.search);
      let ticket = urlParams.get('ticket');

      // 如果search部分没有ticket参数，尝试从hash部分获取
      if (!ticket && window.location.hash) {
        const hashQueryIndex = window.location.hash.indexOf('?');
        if (hashQueryIndex > -1) {
          const hashQuery = window.location.hash.substring(hashQueryIndex + 1);
          const hashParams = new URLSearchParams(hashQuery);
          ticket = hashParams.get('ticket');
        }
      }

      console.log('获取到的ticket参数:', ticket);

      // 更新store中的ticket
      this.$store.state.apiData.ticket = ticket;

      console.log(this.$store.state.apiData.s, ticket, '获取aes');
      // 发起请求，使用获取到的ticket参数
      const res = await userPost('/api/Login/ticketVerify', {
        // project: this.$store.state.apiData.project,
        s: this.$store.state.apiData.s,
        ticket: ticket,
      });

      console.log(res, 'aes');

      // 确保响应有效后再更新aesKey
      if (res && res.data) {
        this.$store.state.apiData.aesKey = res.data;
        // 存储aesKey到本地
        // localStorage.setItem('aesKey', res.data);
      } else {
        console.warn('获取aesKey失败：响应数据无效');
      }
    },
    // 获取用户数据
    async getUserData() {
      try {
        const res = await userPost('/api/login/activeLogin', {
          userLoginData: this.$store.state.apiData.aesKey,
          // s: this.$store.state.apiData.s,
        });

        console.log(res, '用户信息');
        if (res.code == 0) {
          // 更新用户信息
          this.$store.commit('UPDATE_USER_INFO', res.data);
          // 登录保存用户数据到本地
          localStorage.setItem(
            'userInfo'+this.$store.state.isCy,
            JSON.stringify(this.$store.state.userInfo)
          );
          // const urlParams = new URLSearchParams(window.location.search);
          // urlParams.delete('ticket');
          // const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
          // window.history.replaceState({}, '', newUrl);
        } else {
          const urlParams = new URLSearchParams(window.location.search);
          urlParams.delete('ticket');
          const newUrl = window.location.origin;
          window.history.replaceState({}, '', newUrl);
          console.log(e, '登录过期请重新登录');
        }
      } catch (e) {
        if (
          localStorage.getItem('userInfo'+this.$store.state.isCy) &&
          localStorage.getItem('userInfo'+this.$store.state.isCy) !== 'undefined'
        ) {
          this.$store.state.userInfo =
            JSON.parse(localStorage.getItem('userInfo'+this.$store.state.isCy)) || {};
        } else if (localStorage.getItem('userInfo'+this.$store.state.isCy) == 'undefined') {
          localStorage.removeItem('userInfo'+this.$store.state.isCy);
          console.log(e, '登录过期请重新登录');
        }
        console.log(store.state.userInfo, 'store.state.userInfo');
      }
    },

    // 查询自己是否回归
    async oldFriend() {
      const res = await userPost('api/users/isLy', {
        uin: this.$store.state.userInfo?.uin,
      });
      console.log(res, '回归查询');
      if (res.code == 0) {
        this.$store.state.oldFriend = res.data;
        localStorage.setItem('oldFriend', JSON.stringify(res.data));
      }
    },
    // 查询预充值点数
    async getCzData() {
      const res = await userPost('api/users/preRecharge', {
        uin: this.$store.state.userInfo?.uin,
      });
      console.log(res, '充值查询');
      if (res.code == 0) {
        // 存储预充信息到本地
        this.$store.commit('UPDATE_RECHARGE', res.data);
        localStorage.setItem('recharge', JSON.stringify(res.data));
      }
    },
    

    // 获取礼包领取记录
    async getGiftRecord() {
      this.$store.dispatch('fetchGiftRecord');
    },
    // 获取活动配置
    async getActivityConfig() {
      const res = await userPost('api/home/init');
      console.log(res, '活动配置');
      if (res.code == 0) {
        this.$store.state.activityConfig = res.data;
        this.checkTime();
      }
    },
    copyCdk(cdk) {
      if (!cdk) {
        this.$toast('暂无新手卡，请预约');
        return;
      }
      this.$copyText(cdk);
      document.getElementById('diaTipText').innerHTML = '复制成功';
      TGDialogS('diaTip');
    },
    async wxInitShare() {
      try {
        // 1. 获取当前页面实际URL（含别人邀请码，用于签名）
        const currentPageUrl = window.location.href.split('#')[0];
        // 移除可能存在的QQ特殊参数
        console.log(currentPageUrl);

        let shareLink = currentPageUrl;


        // const shareLink = shareUrlObj.toString();
        console.log('最终分享URL:', shareLink);
        const baseShareConfig = {
          title: '马年首服 预约开启',
          desc: this.$store.state.isCy ?'2月24日原始服/常规专区 预约领取累积消费大礼' : '2月24日新服专区 预约领取大礼',
          imgUrl: `${window.location.origin
            }/pkh5/20251120/share-default.png?timestamp=${Date.now()}`,
          link: shareLink,
          success: () => {
            console.log('分享成功');
            this.$store.dispatch('trackShare', 1);
          },
        };
        console.log(baseShareConfig);
        // 4. QQ分享配置
        const qqShareConfig = {
          ...baseShareConfig,
          summary: baseShareConfig.desc,
          imageUrl: baseShareConfig.imgUrl,
          pics: [baseShareConfig.imgUrl],
          success: () => {
            console.log('QQ分享成功');
            this.$store.dispatch('trackShare', 1);
          },
        };

        // 在wxInitShare方法中添加QQ浏览器检测
        const isQQBrowser = /QQ\/([\d.]+)/i.test(navigator.userAgent);
        // 新增QQ分享meta标签动态设置
        if (isQQBrowser) {
          const setQQMeta = () => {
            const metaTags = [
              { property: 'og:title', content: baseShareConfig.title },
              { property: 'og:description', content: baseShareConfig.desc },
              { property: 'og:image', content: baseShareConfig.imgUrl },
              { property: 'og:url', content: shareLink },
            ];

            metaTags.forEach((meta) => {
              let tag = document.querySelector(
                `meta[property='${meta.property}']`
              );
              if (!tag) {
                tag = document.createElement('meta');
                tag.setAttribute('property', meta.property);
                document.head.appendChild(tag);
              }
              tag.setAttribute('content', meta.content);
            });

            // 调用QQ原生API
            if (window.setShareInfo) {
              window.setShareInfo({
                title: baseShareConfig.title,
                summary: baseShareConfig.desc,
                pic: baseShareConfig.imgUrl,
                url: shareLink,
              });
            }
          };

          // 确保DOM加载完成
          if (document.readyState === 'complete') {
            setQQMeta();
          } else {
            window.addEventListener('load', setQQMeta);
          }
        }

        // 3. 通用分享配置

        // 5. 获取微信签名（使用处理后的URL，不含QQ参数）
        const wxConfig = await userPost('/api/WechatService/sign', {
          url: currentPageUrl.replace(/&amp;/g, '&'),
        });
        console.log(wxConfig, 'wxConfig');
        // 6. 初始化微信JS-SDK
        wx.config({
          debug: false,
          appId: wxConfig.data.appId,
          timestamp: wxConfig.data.timestamp,
          nonceStr: wxConfig.data.nonceStr,
          signature: wxConfig.data.signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareQQ',
            'onMenuShareQZone',
          ],
        });

        wx.ready(() => {
          // 7. 设置分享配置
          if (wx.updateAppMessageShareData) {
            wx.updateAppMessageShareData({ ...baseShareConfig });
            wx.updateTimelineShareData({ ...baseShareConfig });
          }

          // 8. 兼容旧版QQ分享接口
          if (wx.onMenuShareQQ) {
            wx.onMenuShareQQ(qqShareConfig);
            wx.onMenuShareQZone({ ...qqShareConfig });
          }

          this.isShareInited = true;
        });

        wx.error((err) => console.error('微信SDK初始化失败:', err));
      } catch (error) {
        console.error('分享配置异常:', error);
      }
    },
    // 判断预约时间和活动时间
    checkTime() {
      const now = Date.now();
      // this.$store.state.activityConfig.reservationEndTime = '2025-07-29 00:00:00';

      const activityData = this.$store.state.activityConfig;
      const startTime = this.convertToTimestamp(activityData.startTime); // 活动开始时间
      const endTime = this.convertToTimestamp(activityData.endTime); // 活动结束时间
      // console.log(startTime, endTime);
      const reservationStartTime = this.convertToTimestamp(
        activityData.reservationStartTime
      ); // 预约开始时间
      const reservationEndTime = this.convertToTimestamp(
        activityData.reservationEndTime
      ); // 预约结束时间
      if (now < startTime) {
        // 活动未开始
        this.$store.state.isActivityNotStarted = true;
        this.$store.dispatch('checkActivityTime');
      } else if (now > endTime) {
        // 活动已结束
        this.$store.state.isActivityEnded = true;
        this.$store.dispatch('checkActivityTime');
      }
      // console.log(now < reservationStartTime, 'reservationStartTime');
      if (now < reservationStartTime) {
        // 预约未开始
        this.$store.state.isReservationStarted = true;
      } else if (now > reservationEndTime) {
        // 预约已结束
        this.$store.state.isReservationEnded = true;
      }
    },
    /**将自定义时间格式转换为时间戳*/
    convertToTimestamp(timeStr) {
      if (!timeStr) return NaN;
      return new Date(timeStr).getTime();
    },
    // 初始化swiper
    initSwiper() {
        this.swiperInstance2 = new Swiper('.cj_prop_swiper', {
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.cj_next',
            prevEl: '.cj_prev',
          },
          observer: true,
          observeParents: true,
          autoHeight: true,
        });
      if (this.$store.state.isPC) {
        this.swiperInstance = new Swiper('.swiper2', {
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },

          pagination: {
            el: '.swiper-pagination1',
            clickable: true,
          },
          observer: true,
          observeParents: true,
          autoHeight: true,
        });
      } else {
        this.swiperInstance = new Swiper('.swiper2', {
          effect: 'coverflow',
          slidesPerView: 'auto',
          centeredSlides: true,
          // paginationClickable: true,
          loop: true,
          autoplay: 2500,
          autoplayDisableOnInteraction: false,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          coverflow: {
            rotate: 0,
            stretch: 160,
            depth: 1100,
            modifier: 1,
            slideShadows: false,
          },
          pagination: {
            el: '.swiper-pagination1',
            clickable: true,
          },
        });
      }
    },
  },
  mounted() {
    this.init();
    this.getActivityConfig();
    this.initSwiper();
    this.wxInitShare();
    // 存储token到cookie里面新增字段TlToken
    document.cookie = `TlToken=${this.$store.state.userInfo?.token}; path=/`;
    console.log(document.cookie.split('; ').find(row => row.startsWith('TlToken=')), 'cookie');
  },
};
</script>

<style lang="scss">
// 引入公共样式
@media screen and (min-width: 1024px) {
  @import '@/assets/css/index.scss';
}

@media screen and (max-width: 1023px) {
  @import '@/assets/css/m.scss';
}
</style>
